//Dependencies
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
//Main Components
import Drawer from '../../../components/Drawer';
//Components
import Virtual01 from '../virtual/Virtual01';
//Actions
import { spotNotificacion } from '../../../store/actions/NotificationsActions';
//Scripts
import { InRange, NearClosed } from '../../../scripts/helpers'; 

const Drawer01 = (props) =>
{
  const { branches, data, filter, influencer, isMobile } = props; 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const drawer01 = useSelector(state => state.drawers.drawer01);

  const [isOpen, setIsOpen] = useState();
  const [itExist, setItExist] = useState();
  const [itNearClosed, setIsNearClosed] = useState();
  const [timeString, setTimeString] = useState();

  const [tiktokButtons, setTiktokButtons] = useState();

  const [socialMediaExist, setSocialMediaExist] = useState(false);
  const [menuExist, setMenuExist] = useState(false);

  /* NOTIFICATION */
  useEffect(() => 
  {
    if(!data) return null;

    spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'open', isMobile);
  }, [isMobile, data]);

  /* GET SCHEDULE */
  useEffect(() => 
  {
    if(!data) return null;

    const date = new Date();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const weekday = date.getDay();

    let scheduleOpen;
    let scheduleExist;
    let scheduleNearClosed;
    let schedule;
    let scheduleString;

    const timeInMinutes = hour * 60 + minute;
    try
    {
      switch(weekday) 
      {
        case 0:
          schedule = data.schedule.sunday;
          break;

        case 1:
          schedule = data.schedule.monday;
          break;

        case 2:
          schedule = data.schedule.tuesday;
          break;

        case 3:
          schedule = data.schedule.wednesday;
          break;

        case 4:
          schedule = data.schedule.thursday;
          break;

        case 5:
          schedule = data.schedule.friday;
          break;

        case 6:
          schedule = data.schedule.saturday;
          break;
        
        default:
          schedule = null;
      }

      if(schedule && schedule.starthour)
      {
        scheduleExist = true;
        const starttimeInMinutes = (schedule.starthour !== 0 ?  schedule.starthour * 60 : 24 * 60) + schedule.startminute;
        const endtimeInMinutes = (schedule.endhour !== 0 ?  schedule.endhour * 60 : 24 * 60) + schedule.endminute;

        scheduleOpen = InRange(starttimeInMinutes, endtimeInMinutes, timeInMinutes);
        scheduleNearClosed = NearClosed(endtimeInMinutes, timeInMinutes);        

        scheduleString = `${schedule.starthour}:${schedule.startminute < 10 ? '0' : ''}${schedule.startminute} - ${schedule.endhour}:${schedule.endminute < 10 ? '0' : ''}${schedule.endminute}`;

        setIsOpen(scheduleOpen);
        setItExist(scheduleExist);
        setIsNearClosed(scheduleNearClosed);
        setTimeString(scheduleString);
      }
      else
      {
        scheduleExist = false;

        setIsOpen(null);
        setItExist(null);
        setIsNearClosed(null);
        setTimeString(null);
      }
    }
    catch (error) 
    {
      console.log(error);
    }
  }, [data]);

  /* GET BUTTONS - INFLUENCERS DE TIKTOK */
  useEffect(() => 
  {
    if(!data) return null;
    if(!data.influencers) return null;

    let socialMediaBool = false;    

    let buttonList01 = Object.keys(data.influencers.tiktok).map((m1, i) => 
    {
      let object = data.influencers.tiktok[m1];

      if(object && object.videoid)
      {
        socialMediaBool = true;
        return(
          <a
            key       = {i}
            target    = '_blank'
            rel       = "noopener noreferrer"
            href      = {`https://vm.tiktok.com/${object.videoid}/`}
            onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, `influencer - ${object.name}`, isMobile)}
            className = "h-[40px] w-[300px] flex justify-center bg-transparent uppercase hover:bg-sky-500 text-gray-800 font-semibold hover:text-white border-2 border-gray-800 hover:border-transparent rounded my-1 cursor-pointer"
          >
            <h1 className = 'flex items-center m-0'>
              {object.name}
            </h1>
          </a>
        );
      }
      else
      {
        return null;
      }
    });    

    setSocialMediaExist(socialMediaBool);
    setTiktokButtons(buttonList01);
  }, [isMobile, data]);

  /* GET MENU */
  useEffect(() => 
  {
    if(!data) return null;

    let menuBool = false;
    
    Object.keys(data.menu).forEach((object) => 
    {
      console.log(object);
      if(object)
      {
        menuBool = true;
      }
    })

    setMenuExist(menuBool);
  }, [data]);  

  const copyLinkClick = () =>
  {
    let enlace = window.location.href;
    let message = `Visita ${data.info.name.toUpperCase()} en la página web de VIVE EN 360. Haz click en el siguiente enlace: ${enlace}`

    spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'link', isMobile);

    navigator.clipboard.writeText(message);

    toastr.success("VIVE EN 360", 'Enlace Copiado!!!');
  };

  const closeDrawer = () =>
  {
    const scroller = document.querySelector("#scroller");
    if(influencer)
    {
      navigate(`/?by=${influencer}`);
    }
    else if (filter)
    {
      navigate(`/?f=${filter}`);
    }
    else
    {
      navigate(`/`);
    }

    scroller.scrollTo(0,0);
   
    dispatch({type: 'SET_MARKERS_SELECTED', selected : null});
    dispatch({type: 'SET_MARKERS_SELECTED_BRANCHES', selectedBranches : null});    
    dispatch({type: 'SET_DRAWER_01', drawer01 : false});
  };

  const clickBranch = (url) =>
  {
    navigate(`/`);
    
    dispatch({type: 'SET_DRAWER_01', drawer01 : false});   
    dispatch({type: 'SET_MARKERS_SELECTED', selected : null});
    dispatch({type: 'SET_MARKERS_SELECTED_BRANCHES', selectedBranches : null});       

    setTimeout(() => 
    {
      navigate(`/${url}`);
    }, 200);
  };

  
  return(
    <Drawer
      height    = {window.innerWidth < '1024' ? 80 : data && data.links.menu ? data && data.links.delivery  && (data.links.delivery.pedidosya || data.links.delivery.rappi || data.links.delivery.uber || data.links.delivery.online) ? 75 : 65 : data && data.links.delivery  && (data.links.delivery.pedidosya || data.links.delivery.rappi || data.links.delivery.uber || data.links.delivery.online) ? 70 : 60}
      visible   = {drawer01}
      onClose   = {() => closeDrawer()}      
    >
      <div className = "w-full bg-white select-none">
        <div className = "flex bg-white"  >
          <div className = "flex items-center flex-col text-center px-6 lg:text-left lg:w-1/2 lg:min-h-[500px] md:px-12 md:w-full sm:w-full w-full" >
            <div className = "w-full">
              {data && 
                <h2 className = "text-xl font-bold text-gray-800 uppercase md:text-4xl mt-3 mb-1">
                  {data.info.name} {data.info.branch ? ` - ${data.info.branch}` : null}
                </h2>
              }
              
              {/* HORARIO */}
              {data && 
                <h3 className = "font-bold text-center inline-flex items-center justify-center md:text-xl text-base uppercase">
                  {isOpen && !itNearClosed && itExist &&
                    <span
                    className = {'text-green-500'}
                  >
                    {`ABIERTO (${timeString})`}
                  </span>
                  }

                  {isOpen && itNearClosed && itExist &&
                  <span
                    className = {'text-orange-600'}
                  >
                    {`ABIERTO (${timeString})`}
                  </span>
                  }

                  {!isOpen && itExist &&
                    <span
                      className = {'text-red-500'}
                    >
                      {`CERRADO (${timeString})`}
                    </span>
                  }

                  {!itExist &&
                    <span
                      className = {'text-red-500'}
                    >
                      {`HOY NO ABRE`}
                    </span>
                  }
                </h3>
              }
            </div>

            <div 
              className = "flex shadow-xl justify-center lg:hidden"
              style   =
              {{
                height      : `${window.innerWidth < 500 ? 500 : window.innerWidth}px`,
                width       : `${window.innerWidth < 500 ? 500 : window.innerWidth}px`,
                maxHeight   : '430px',
                maxWidth    : '430px'
              }}
            >
              {data && data.info.image360 && window.innerWidth < '1024' &&
                <Virtual01
                  panoURL   = {data.info.image360}
                  data      = {data}
                  isMobile  = {isMobile}
                />
              }

              {data && !data.info.image360 && data.info.thumbnail && window.innerWidth < '1024' &&
                <div 
                  className = "h-full bg-center bg-contain " 
                  style = {{height: '100%', width:'100%' ,backgroundImage: `url(${data.info.thumbnail})`}}>
                  <div className = "h-full bg-black opacity-25"></div>
                </div>
              }
            </div>
            
            <div className = "w-full">
              {/* LOCATION */}
              <div className = 'flex items-center justify-evenly my-6 w-full'>
          
                {data && data.links.waze && data.links.wazeenabled &&
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {isMobile ? `waze://?ll=${data.info.location[0]},${data.info.location[1]}&navigate=yes` : data.links.waze}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'waze', isMobile)}
                    >
                      <i className = "fab fa-waze" ></i>
                    </a>
                  </div>
                }                

                {data && data.links.maps && console.log( `comgooglemaps://?center=${(data.info.location[0])},${data.info.location[1]}&zoom=${17}&destination=${(data.info.location[0])},${data.info.location[1]}&travelmode=driving`)}

                {data && data.links.maps && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"                      

                      //href = { isMobile ? `comgooglemaps://?center=${data.info.location[0]},${data.info.location[1]}&zoom=${17}&destination=${data.info.location[0]},${data.info.location[1]}&travelmode=driving` : data.links.maps}

                      href = { data.links.maps }
                      
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'maps', isMobile)}
                    >
                      <i className = "fas fa-map-marked"></i>
                    </a>
                  </div>
                }

                {data && data.links.gsv && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {`https://goo.gl/maps/${data.links.gsv}`}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'gsv', isMobile)}
                    >
                      <i className = "fas fa-street-view"></i>
                    </a>
                  </div>
                }

                {data && data.links.webpage && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {data.links.webpage}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'webpage', isMobile)}
                    >
                      <i className = "fas fa-globe"></i>
                    </a>
                  </div>
                }
              </div>

              {/* SOCIAL */}
              <div className = 'flex items-center justify-evenly my-6 w-full'>
                {data && 
                  <div
                    className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer"
                    onClick   = {() => copyLinkClick()}
                  >
                    <div
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                    >
                      <i className = "fas fa-link"></i>
                    </div>
                  </div>
                }

                {data && data.links.whatsapp && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = { isMobile ? `whatsapp://send?phone=${data.links.whatsapp}&text=Saludos, los encontré en VIVE EN 360` : `https://web.whatsapp.com/send?phone=${data.links.whatsapp}&text=Saludos, los encontré en VIVE EN 360`}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'whatsapp', isMobile)}
                    >
                      <i className = "fab fa-whatsapp"></i>
                    </a>
                  </div>
                }

                {data && data.links.instagram && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {isMobile ? `instagram://user?username=${data.links.instagram}` : `https://www.instagram.com/${data.links.instagram}`}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'instagram', isMobile)}
                    >
                      <i className = "fab fa-instagram"></i>
                    </a>
                  </div>
                }

                {data && data.links.facebook && 
                  <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {isMobile ? `fb://page/?id=${data.links.facebook}` : `https://www.facebook.com/${data.links.facebook}`}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'facebook', isMobile)}
                    >
                      <i className = "fab fa-facebook-f"></i>
                    </a>
                  </div>
                }

                {data && data.links.tiktok && 
                  <div className = "lg:text-4xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                    <a
                      className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                      target = '_blank'
                      rel = "noopener noreferrer"
                      href = {`https://www.tiktok.com/@${data.links.tiktok}`}
                      onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'tiktok', isMobile)}
                    >
                      <i className = "fab fa-tiktok"></i>
                    </a>
                  </div>
                }
              </div>

              {/* DELIVERY */}
              {data && data.links.delivery && (data.links.delivery.pedidosya || data.links.delivery.rappi || data.links.delivery.uber || data.links.delivery.online) &&
                <div className = 'flex items-center justify-center my-6'>
                  {data.links.delivery.online && 
                    <div className = 'flex items-center justify-center'>          
                      <a
                        target = '_blank'
                        rel = "noopener noreferrer"
                        href = {data.links.delivery.online}
                        onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'delivery', isMobile)}
                        className = "h-[40px] mx-2 items-center flex justify-center bg-transparent hover:bg-emerald-600 text-emerald-500 font-semibold hover:text-white px-4 border-2 border-emerald-500 hover:border-transparent rounded cursor-pointer"
                      >
                        DELIVERY
                      </a>
                    </div>
                  }

                  {data.links.delivery.pedidosya && 
                    <div className = 'flex items-center justify-center'>          
                      <a
                        target = '_blank'
                        rel = "noopener noreferrer"
                        href = {data.links.delivery.pedidosya}
                        onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'delivery - pedidosya', isMobile)}
                        className = "h-[40px] mx-2 items-center flex justify-center bg-transparent hover:bg-emerald-600 text-emerald-500 font-semibold hover:text-white px-4 border-2 border-emerald-500 hover:border-transparent rounded cursor-pointer"
                      >
                        PEDIDOS YA
                      </a>
                    </div>
                  }

                  {data.links.delivery.uber && 
                    <div className = 'flex items-center justify-center'>          
                      <a
                        target = '_blank'
                        rel = "noopener noreferrer"
                        href = {data.links.delivery.uber}
                        onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'delivery - uber eats', isMobile)}
                        className = "h-[40px] mx-2 items-center flex justify-center bg-transparent hover:bg-emerald-600 text-emerald-500 font-semibold hover:text-white px-4 border-2 border-emerald-500 hover:border-transparent rounded cursor-pointer"
                      >
                        UBER
                      </a>
                    </div>
                  }

                  {data.links.delivery.rappi && 
                    <div className = 'flex items-center justify-center'>          
                      <a
                        target = '_blank'
                        rel = "noopener noreferrer"
                        href = {data.links.delivery.rappi}
                        onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'delivery - rappi', isMobile)}
                        className = "h-[40px] mx-2 items-center flex justify-center bg-transparent hover:bg-emerald-600 text-emerald-500 font-semibold hover:text-white px-4 border-2 border-emerald-500 hover:border-transparent rounded cursor-pointer"
                      >
                        RAPPI
                      </a>
                    </div>
                  }
                </div>
              }

              {/* MENU LINK */}
              {data && data.links.menu && 
                <div className = 'flex items-center justify-center'>          
                  <a
                    target = '_blank'
                    rel = "noopener noreferrer"
                    href = {data.links.menu}
                    onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'menu', isMobile)}
                    className = "h-[40px] w-[300px] flex justify-center bg-transparent hover:bg-sky-500 text-gray-800 font-semibold hover:text-white border-2 border-gray-800 hover:border-transparent rounded my-1 cursor-pointer"
                  >
                    <h1 className = 'flex items-center m-0'>
                      MENU
                    </h1>
                  </a>
                </div>
              }

              {/* TIKTOK INFLUENCERS */}
              {socialMediaExist &&
                <div>
                  <h3 className = "flex justify-center mt-2 text-3xl text-blue-600 font-semibold">
                    INFLUENCERS - TIKTOK
                  </h3>

                  <div className = 'flex flex-col  items-center lg:h-[150px]'>                    
                    {tiktokButtons}
                  </div>
                </div>
              }
            </div>
          </div>          
          
          <div 
            className = "hidden lg:block lg:w-1/2"
            style   =
            {{
              clipPath : 'polygon(10% 0, 100% 0%, 100% 100%, 0 100%)'
            }}
          >
            {data && data.info.image360 &&
              <Virtual01
                panoURL   = {data.info.image360}
                data      = {data}
                isMobile  = {isMobile}
              />
            }

            {data && !data.info.image360 && data.info.thumbnail &&
              <div 
                className = "h-full bg-center bg-cover " 
                style = {{backgroundImage: `url(${data.info.thumbnail})`}}>
                <div className = "h-full bg-black opacity-25"></div>
              </div>
            }
          </div>          
        </div>
        
        {/* BRANCHES */}
        {data && branches &&
          <div className = "flex flex-col justify-center items-center bg-white mt-3">
            <h2 className = "uppercase text-3xl font-bold text-gray-800 md:text-4xl mb-1">
              SUCURSALES
            </h2>

            <div className = 'flex items-center justify-center my-1'>
              <div
                className = 'flex items-center justify-center'
              >
                <div
                  className   = {`h-[40px] uppercase mx-2 items-center flex text-emerald-500 justify-center bg-transparent font-semibold px-4 border-2 border-emerald-500 rounded cursor-pointer hover:text-white hover:bg-emerald-600 hover:border-transparent`}
                  onClick     = {() => clickBranch(data.info.username)}
                >
                  TODAS
                </div>
              </div>
              
              {branches && Object.keys(branches).map((m1, i) => 
                {
                  let info = branches[m1];
                  return(
                    <div
                      key = {i}
                      className = 'flex items-center justify-center'
                    >
                      <div
                        className   = {`h-[40px] uppercase mx-2 items-center flex justify-center bg-transparent ${info.info.branch === data.info.branch ? 'bg-emerald-100' : ''} ${info.info.branch === data.info.branch ? 'text-black' : 'text-emerald-500'} font-semibold px-4 border-2 border-emerald-500 rounded ${info.info.branch === data.info.branch ? '' : 'cursor-pointer hover:text-white hover:bg-emerald-600 hover:border-transparent'}`}
                        onClick     = {info.info.branch === data.info.branch ? null : () => clickBranch(`${info.info.username}?s=${info.info.branchurl}`) }
                      >
                        {info.info.branch}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        }

        {menuExist &&
          <div className = "flex flex-col justify-center items-center bg-white mt-3">
            <h2 className = "uppercase text-3xl font-bold text-gray-800 md:text-4xl mb-2">
              MENU
            </h2>

            <h3 className = "flex justify-center mt-2 mb-2 text-3xl text-blue-600 font-semibold">
              ENTRADAS
            </h3>

            <div className = "w-full flex mb-10">
              <main className = "w-full overflow-y-auto">          
                <div className = "px-10 grid grid-cols-4 gap-4">
                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>

            <h3 className = "flex justify-center mt-2 text-3xl text-blue-600 font-semibold">
              PLATOS PRINCIPALES
            </h3>

            <div className = "w-full flex mb-10">
              <main className = "w-full overflow-y-auto">          
                <div className = "px-10 grid grid-cols-4 gap-4">
                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className = "col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1 xl:col-span-1 flex flex-col items-center"
                  >
                    <div className = "bg-white rounded-lg mt-5">
                      <img
                        src = "https://source.unsplash.com/MNtag_eXMKw/1600x900"
                        className = "h-40 rounded-md object-cover"
                        alt = ""
                      />
                    </div>

                    <div className = "bg-white shadow-lg rounded-lg -mt-4 w-64 border-2 border-gray-200">
                      <div className = "py-5 px-5">
                        <span className = "font-bold text-gray-800 text-lg">Geek Pizza</span>
                        <div className = "flex items-center justify-between">
                          <div className = "text-sm text-gray-600 font-light">
                            Size : Regular
                          </div>
                          <div className = "text-2xl text-red-600 font-bold">
                            $ 8.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        }

        <div className = "flex justify-center bg-white"  >
          <button
              className = 'bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 border border-red-700 rounded lg:w-1/4 w-2/3 text-lg tracking-widest mb-2 mt-5'
              onClick={() => 
                {
                  closeDrawer();
                }}
            >
              CERRAR
            </button>
        </div>        
      </div>
    </Drawer>
  );
}

export default Drawer01;